import React, { useState } from 'react';
import { StyledTable } from 'adapter/in/common/components/HomeTable/style';
import i18n from 'asset/translation';
import { Result, Heading, ResultVariants } from '@dexma/ui-components';
import Bot from 'asset/images/bot.svg';
import { MarketAppView } from 'domain/entity/market/marketApp';

export type MarketAppTableProps = {
    columns: any | null;
    dataSource: MarketAppView[] | null;
    isLoading: boolean;
    showError: boolean;
};

const MarketAppTable = (props: MarketAppTableProps) => {
    const { columns, dataSource, isLoading, showError } = props;
    const [currentPage, setCurrentPage] = useState(1);

    const onPageChange = (page: number) => setCurrentPage(page);

    const dataSourcePaginated = () => {
        const startIndex = (currentPage - 1) * 10;
        return dataSource?.slice(startIndex, startIndex + 10)?.map((source) => ({ ...source, key: source.id }));
    };

    return (
        <>
            <Heading text={i18n.t('dashboards.marketAppsTitle')} type='h2' />
            <StyledTable
                data-testid='apps-table'
                columns={columns}
                dataSource={dataSourcePaginated()}
                isLoading={isLoading}
                showError={showError}
                errorContent={
                    <Result
                        variant={ResultVariants.DEFAULT}
                        title={i18n.t('common.errorWrong')}
                        info={i18n.t('common.errorWrongInfo')}
                        iconElement={<Bot />}
                    />
                }
                currentPage={currentPage}
                totalRegisters={dataSource ? dataSource.length : 0}
                pageSize={10}
                onPageChange={onPageChange}
                prevPageAriaLabel={i18n.t('common.ariaLabel.tablePagination.prevPage')}
                prevDotsPageAriaLabel={i18n.t('common.ariaLabel.tablePagination.prevDotsPage')}
                nextDotsPageAriaLabel={i18n.t('common.ariaLabel.tablePagination.nextDotsPage')}
                nextPageAriaLabel={i18n.t('common.ariaLabel.tablePagination.nextPage')}
            />
        </>
    );
};

export default MarketAppTable;
